import { defineMessages } from 'react-intl';

type MessageKeys = 'label';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> = defineMessages({
	label: {
		id: 'fabric.editor.ai.screens.prompt.linkPickerButton.label',
		defaultMessage: 'Add link',
		description: 'Link picker button label within the Prompt screen',
	},
});

export default message;
